import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="test-timer"
export default class extends Controller {
  static targets = [ "draftBtn", "submitBtn", "display", "flashMessage" ]
  static values = { isStudentType: Boolean }

  initialize() {
    this.time = Number(this.displayTarget.dataset.time)
    this.hour = 0
    this.min = 0
    this.sec = 0
  }

  connect() {
    this.intervalId = setInterval(() => {
      this.timer()
    }, 1000)

    setTimeout(() => {
      this.flashMessageTarget.style.display = 'none';
    }, 2000);
  }

  // 制限時間
  timer() {
    this.time = this.time - 1
    this.hour = parseInt(this.time / 3600)
    this.min = parseInt((this.time / 60) % 60)
    this.sec = this.time % 60

    if(this.hour < 10) { this.hour = "0" + this.hour }
    if(this.min < 10) { this.min = "0" + this.min }
    if(this.sec < 10) { this.sec = "0" + this.sec }

    const result = this.hour + ':' + this.min + ':' + this.sec
    this.displayTarget.innerHTML = result

    if(this.isStudentTypeValue) {
      if(this.time == 0) {
        this.submitBtnTarget.click()
      } else if(this.time % 5 == 0) {
        this.draftBtnTarget.click()
      }
    }
  }
}
